// extracted by mini-css-extract-plugin
export default {"modalContent":"MatchExternalTransactionModal_modalContent__WacOz"};